import React from 'react';
import iconify from '../iconify';

const EyeOutlineIcon = ({customColor, ...props}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23.79"
    height="12.305"
    viewBox="0 0 23.79 12.305"
    {...props}
  >
    <g id="Group_891" data-name="Group 891" transform="translate(-568 5.41)">
      <path
        id="Path_533"
        data-name="Path 533"
        d="M590.632.3a14.919,14.919,0,0,0-23.473,0,.7.7,0,0,0,0,.888A16.3,16.3,0,0,0,578.9,6.9a16.334,16.334,0,0,0,11.737-5.709A.7.7,0,0,0,590.632.3Zm-6.983.444a4.753,4.753,0,1,1-9.506,0,4.753,4.753,0,1,1,9.506,0Zm-15,0A16.9,16.9,0,0,1,574-2.976a6.137,6.137,0,0,0,0,7.436A16.592,16.592,0,0,1,568.645.743Zm15.149,3.718a6.137,6.137,0,0,0,0-7.436A16.6,16.6,0,0,1,589.145.742,16.9,16.9,0,0,1,583.793,4.461Z"
        transform="translate(1)"
        fill="#fff"
      />
      <path
        id="Path_534"
        data-name="Path 534"
        d="M771.8,78.179a2.379,2.379,0,1,0,2.379-2.379A2.382,2.382,0,0,0,771.8,78.179Zm3.359,0a.98.98,0,1,1-.979-.98A.981.981,0,0,1,775.159,78.179Z"
        transform="translate(-194.284 -77.437)"
        fill="#fff"
      />
    </g>
  </svg>
);

export default iconify(EyeOutlineIcon);
